import { Box, Paper, Stack } from "@mui/material";
import React from "react";
import FormikTextField from "../../form/FormikTextField";

const ServiceForm = () => {
  return (
    <Paper elevation={1} sx={{ borderRadius: 2 }}>
      <Stack px={2} py={3} gap={2} >
        {/* Service name input */}
        <FormikTextField label="Service Name" name="serviceName" />

        {/* Description input */}
        <FormikTextField
          label={"Description"}
          name="description"
          multiline
          rows={4}
        />
      </Stack>
    </Paper>
  );
};

export default ServiceForm;
